import { OffersGetAllQuery } from '../../types';
import { Chip, Typography } from '../../design-system';
import { CardBase, CardInfo, ContainerPhoto } from '../dashboard';
import { formatContainerType, momentTextFormat } from '../../utils';
import { OfferStatusReceivedToChipLabels, OfferStatusSentToChipLabels } from '../../const';
import { useStore } from '../../context';

interface CardProps {
  handleClickImage: any;
  handleDotsOptionSelect: any;
  states: any;
}

export const Card = ({
  handleClickImage,
  states,
  ...offer
}: CardProps & OffersGetAllQuery['data'][number]) => {
  const {
    state: {
      user: { data: user },
    },
  } = useStore();

  return (
    <CardBase>
      <ContainerPhoto
        src={offer.container.images[0].url}
        onClick={(e) => {
          e.stopPropagation();
          handleClickImage(offer.container.images);
        }}
      />
      <CardInfo>
        <Typography variant={'textS'}>{offer.container.number}</Typography>
        <Typography variant={'textS'} weight={'bold'}>
          {offer.price[0]}$
        </Typography>
      </CardInfo>
      <CardInfo column={'max-content'}>
        <Chip
          size={'small'}
          label={
            (states.offerDirection === 'sent'
              ? OfferStatusSentToChipLabels
              : OfferStatusReceivedToChipLabels)[offer.status]
          }
          color={'borderless'}
        />
      </CardInfo>
      <CardInfo column={'max-content 1fr max-content'}>
        <Chip
          size={'small'}
          label={formatContainerType(offer.container.type)}
          color={'borderless'}
        />
        <span />
        <Typography variant={'textS'} weight={'bold'}>
          {offer.createdAt ? momentTextFormat(offer.createdAt, user, true) : ''}
        </Typography>
      </CardInfo>
    </CardBase>
  );
};
